<template lang="html">
  <div  :style="{ 'padding-top': offsetHeight + 'px' }">
    <van-nav-bar
      :fixed="true"
      title="播放记录"
      left-text="返回"
      right-text="全部清除"
      left-arrow
      @click-left="onClickLeft"
      @click-right="onClickRight"
      ref="navBar"
    />
    <episode-list
      ref="episodeList"
      :slug="slug"
      :editorChoiceOnly="false"
      :premiumOnly="false"
      :playHistory="true"
      :limit="0"
    />
  </div>
</template>

<script>
  import Vue from 'vue'
  import { NavBar } from 'vant'
  import { Notify } from 'vant'
  import EpisodeList from '../episode-list.vue'
  Vue.use(NavBar)
  Vue.use(Notify)
  export default {
    components: {
      EpisodeList
    },
    data () {
      return {
        slug: '',
        offsetHeight: 0
      }
    },
    watch:{
      // $route(to, from) {
      //   this.slug = ''
      //   window.console.log(to)
      //   window.console.log(from)
      //   this.slug = this.$route.params.slug
      // }
    },
    methods: {
      onClickLeft() {
        this.$router.replace({
          name: `UserCenterIndex`,
          params: {
            slug: this.slug
          }
        })
      },
      onClickRight() {
        let that = this
        that.$api.history.clear().then(res => {
          window.console.log("清除记录")
          window.console.log(res)
          that.$refs.episodeList.getEpisodes()
          let deletedCount = res.data.deleted_count
          Notify(
            { type: 'success', message: `已清除${deletedCount}条播放记录` })
        })
      }
    },
    mounted () {
      window.console.log("启动历史页面")
      this.slug = this.$route.params.slug
      this.$nextTick(function() {
        // this.offsetHeight = this.$refs.navBar.offsetHeight
        this.offsetHeight = this.$refs.navBar.$el.offsetHeight
      })
    }
  }
</script>

<style lang="css" scoped>
</style>
